import { useTranslation } from "react-i18next";
import EntityTable from "../../../../common/tables/EntityTable";
import useMissionRequestsColumns from "../../../../../hooks/useMissionRequestsColumns";
import { getAllSentRequestsFilter } from "../../../../../common/queries";
import { useStation } from "../../../../../providers/StationProvider";
import { useMemo } from "react";

export default function AllRequestsSection(props) {
  const { onRowClick } = props;
  const { t } = useTranslation();

  const { station } = useStation();
  const columns = useMissionRequestsColumns(false, null, null, true, true); 
  const filter = useMemo(() => getAllSentRequestsFilter(station), [station]);

  return !!station ? (
    <EntityTable
      tableId="all_requests_section_sent"
      type="MissionRequest"
      onRowClick={onRowClick}
      filter={filter}
      columns={columns}
      serverSidePaging
      emptyStateTitle={t("missionRequests:allRequestsSection:emptyStateTitle")}
      emptyStateDescription={t("missionRequests:allRequestsSection:emptyStateDescription")}
      sortDescendingByDefault
      xs={12}
    />
  ) : null;
}
